export default __webpack_public_path__ + "static/media/jewelry-dark-autumn.9bed4481.png";